import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../constants/common'

import { hasDraft, isDraftLoading } from './DraftAddEntityButton.utils'

function DraftAddEntityButton({
  Button,
  Select,
  buttonProps = EMPTY_OBJECT,
  draft,
  draftId,
  initialValues,
  isSkeleton = false,
  selectProps = EMPTY_OBJECT,
  onAction = EMPTY_FUNCTION,
}) {
  return hasDraft(draftId, draft) ? (
    <Select
      {...selectProps}
      draft={draft}
      initialValues={initialValues}
      isSkeleton={isSkeleton}
      onAction={onAction}
    />
  ) : (
    <Button
      {...buttonProps}
      initialValues={initialValues}
      isSkeleton={isSkeleton || isDraftLoading(draftId, draft)}
      onAction={onAction}
    />
  )
}

export default DraftAddEntityButton
